import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../hooks/useApi';
import {
  ReceiptIcon, RefreshIcon, PackageIcon, ArrowRightIcon, StarIcon,
  ReturnIcon, CalendarIcon, ClockIcon, CheckIcon, AlertIcon, XIcon,
  MessageIcon,
} from '../../components/Icons';

const ESTADOS = {
  pendente:                 { label:'Pendente',            cls:'badge-warning',  desc:'A aguardar confirmação do fornecedor' },
  confirmada:               { label:'A preparar',          cls:'badge-info',     desc:'Fornecedor a preparar — mostra o teu código na entrega' },
  em_transito_entrega:      { label:'Em trânsito',         cls:'badge-info',     desc:'O fornecedor está a caminho — mostra o teu código' },
  aguardando_levantamento:  { label:'Pronto p/ levantar',  cls:'badge-info',     desc:'Dirige-te ao ponto de levantamento e introduz o código do fornecedor' },
  aluguer_ativo:            { label:'Aluguer activo',      cls:'badge-success',  desc:'Estás a usar o produto. Inicia a devolução quando terminares.' },
  em_transito_devolucao:    { label:'Em devolução',        cls:'badge-neutral',  desc:'Devolução em curso — confirma com o código OTP' },
  em_inspecao:              { label:'Em inspeção',         cls:'badge-neutral',  desc:'O fornecedor está a inspecionar o produto devolvido' },
  entregue:                 { label:'Entregue',            cls:'badge-success',  desc:'O produto foi-te entregue' },
  em_uso:                   { label:'Em uso',              cls:'badge-success',  desc:'Estás a usar o produto' },
  devolvida:                { label:'Devolvida',           cls:'badge-neutral',  desc:'Produto devolvido, aguarda liquidação' },
  concluida:                { label:'Concluída',           cls:'badge-success',  desc:'Reserva concluída com sucesso' },
  cancelada:                { label:'Cancelada',           cls:'badge-danger',   desc:'Esta reserva foi cancelada' },
  disputa:                  { label:'Em disputa',          cls:'badge-danger',   desc:'Existe um conflito nesta reserva' },
};

function ModalAvaliacao({ reserva, onClose, onSucesso }) {
  const [nota,       setNota]       = useState(5);
  const [hoverNota,  setHoverNota]  = useState(0);
  const [comentario, setComentario] = useState('');
  const [loading,    setLoading]    = useState(false);
  const [erro,       setErro]       = useState('');

  const submeter = async () => {
    setLoading(true); setErro('');
    try {
      await apiFetch('/avaliacoes', 'POST', {
        reserva_id:  reserva.id,
        avaliado_id: reserva.fornecedor_id,
        anuncio_id:  reserva.anuncio_id,
        nota,
        comentario,
        tipo: 'cliente_para_fornecedor',
      });
      onSucesso();
      onClose();
    } catch (e) {
      setErro(e.message || 'Erro ao enviar avaliação');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.65)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
      <div style={{background:'var(--card)',borderRadius:'16px',padding:'24px',width:'100%',maxWidth:'420px',border:'1px solid var(--border)'}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'20px'}}>
          <div>
            <div style={{fontSize:'16px',fontWeight:'700',color:'var(--text-primary)'}}>Avaliar reserva</div>
            <div style={{fontSize:'12px',color:'var(--text-muted)',marginTop:'2px'}}>{reserva.titulo || 'Produto'}</div>
          </div>
          <button onClick={onClose} style={{background:'none',border:'none',cursor:'pointer',padding:'4px',display:'flex',alignItems:'center'}}>
            <XIcon size={18} color='var(--text-muted)'/>
          </button>
        </div>

        {/* Stars */}
        <div style={{textAlign:'center',marginBottom:'20px'}}>
          <div style={{fontSize:'13px',color:'var(--text-secondary)',marginBottom:'10px'}}>Como foi a tua experiência?</div>
          <div style={{display:'flex',justifyContent:'center',gap:'6px'}}>
            {[1,2,3,4,5].map(n => (
              <button key={n}
                onMouseEnter={() => setHoverNota(n)}
                onMouseLeave={() => setHoverNota(0)}
                onClick={() => setNota(n)}
                style={{background:'none',border:'none',cursor:'pointer',padding:'2px',transition:'transform 0.1s'}}
                onMouseDown={e => e.currentTarget.style.transform='scale(0.9)'}
                onMouseUp={e => e.currentTarget.style.transform='scale(1)'}>
                <StarIcon size={32}
                  color={(hoverNota||nota) >= n ? '#f59e0b' : 'var(--border)'}
                  fill={(hoverNota||nota) >= n ? '#f59e0b' : 'none'}/>
              </button>
            ))}
          </div>
          <div style={{fontSize:'12px',color:'var(--text-muted)',marginTop:'6px'}}>
            {['','Muito mau','Mau','Razoável','Bom','Excelente!'][hoverNota||nota]}
          </div>
        </div>

        {/* Comentário */}
        <div style={{marginBottom:'16px'}}>
          <label style={{fontSize:'12px',color:'var(--text-secondary)',fontWeight:'500',display:'block',marginBottom:'6px'}}>Comentário (opcional)</label>
          <textarea
            value={comentario}
            onChange={e => setComentario(e.target.value)}
            placeholder="Partilha a tua experiência com este fornecedor..."
            style={{width:'100%',padding:'10px 12px',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'8px',fontSize:'13px',color:'var(--text-primary)',fontFamily:'inherit',outline:'none',resize:'vertical',minHeight:'80px',boxSizing:'border-box'}}
          />
        </div>

        {/* Fornecedor info */}
        <div style={{background:'var(--surface)',borderRadius:'8px',padding:'10px 12px',marginBottom:'16px',display:'flex',alignItems:'center',gap:'10px'}}>
          <div style={{width:'32px',height:'32px',borderRadius:'50%',background:'var(--orange)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'12px',color:'#fff',fontWeight:'700',flexShrink:0}}>
            {(reserva.fornecedor_nome||'?')[0].toUpperCase()}
          </div>
          <div>
            <div style={{fontSize:'12px',fontWeight:'600',color:'var(--text-primary)'}}>Fornecedor: {reserva.fornecedor_nome}</div>
            <div style={{fontSize:'11px',color:'var(--text-muted)'}}>A tua avaliação ajuda outros utilizadores</div>
          </div>
        </div>

        {erro && <div style={{background:'var(--danger-bg)',border:'1px solid var(--danger-border)',borderRadius:'8px',padding:'9px 12px',fontSize:'12px',color:'var(--danger)',marginBottom:'12px',display:'flex',gap:'6px',alignItems:'center'}}><AlertIcon size={13}/>{erro}</div>}

        <div style={{display:'flex',gap:'8px'}}>
          <button onClick={onClose} className="btn btn-ghost" style={{flex:1}}>Cancelar</button>
          <button onClick={submeter} disabled={loading} className="btn btn-primary" style={{flex:2,display:'flex',alignItems:'center',justifyContent:'center',gap:'6px'}}>
            {loading ? 'A enviar...' : <><StarIcon size={13}/> Publicar avaliação</>}
          </button>
        </div>
      </div>
    </div>
  );
}

const ESTADOS_ATIVOS = ['pendente','confirmada','em_transito_entrega','aguardando_levantamento','aluguer_ativo','em_transito_devolucao','em_inspecao','entregue','em_uso','devolvida','disputa'];
const ESTADOS_CHAT   = ['confirmada','em_transito_entrega','aguardando_levantamento','aluguer_ativo','em_transito_devolucao','em_inspecao','entregue','em_uso','devolvida','disputa'];

function PainelOtp({ titulo, instrucao, otp, onBuscarOtp, inputVal, onChangeInput, onConfirmar, loading, erro, confirmLabel }) {
  return (
    <div style={{background:'var(--orange-light)',border:'1.5px solid var(--orange)',borderRadius:'10px',padding:'14px 16px',marginTop:'10px'}}>
      <div style={{fontSize:'13px',fontWeight:'700',color:'var(--orange-dark)',marginBottom:'4px'}}>{titulo}</div>
      <div style={{fontSize:'12px',color:'var(--text-secondary)',marginBottom:'10px'}}>{instrucao}</div>
      {otp ? (
        <div style={{textAlign:'center',background:'var(--card)',borderRadius:'8px',padding:'12px',border:'1px solid var(--orange)'}}>
          <div style={{fontSize:'11px',color:'var(--text-muted)',marginBottom:'4px',textTransform:'uppercase',letterSpacing:'0.5px'}}>O teu código</div>
          <div style={{fontSize:'36px',fontWeight:'900',letterSpacing:'10px',color:'var(--orange)',fontVariantNumeric:'tabular-nums'}}>{otp}</div>
          <div style={{fontSize:'11px',color:'var(--text-muted)',marginTop:'4px'}}>Mostra verbalmente ao fornecedor</div>
        </div>
      ) : onBuscarOtp ? (
        <button className="btn btn-sm" onClick={onBuscarOtp} disabled={loading} style={{background:'var(--orange)',color:'#fff',border:'none',width:'100%',justifyContent:'center'}}>
          {loading ? 'A carregar...' : 'Ver o meu código'}
        </button>
      ) : null}
      {onConfirmar && (
        <div style={{marginTop:'10px'}}>
          <div style={{fontSize:'11px',color:'var(--text-secondary)',marginBottom:'5px'}}>Introduz o código recebido do fornecedor:</div>
          <div style={{display:'flex',gap:'6px'}}>
            <input value={inputVal} onChange={e=>onChangeInput(e.target.value.replace(/\D/,'').slice(0,4))}
              maxLength={4} placeholder="••••"
              style={{flex:1,padding:'9px 12px',border:'1.5px solid var(--border)',borderRadius:'8px',fontSize:'20px',fontWeight:'700',textAlign:'center',letterSpacing:'8px',fontFamily:'inherit',outline:'none',background:'var(--card)',color:'var(--text-primary)'}}/>
            <button className="btn btn-primary" onClick={onConfirmar} disabled={loading||inputVal.length!==4}
              style={{display:'flex',alignItems:'center',gap:'5px',whiteSpace:'nowrap'}}>
              {loading?'...': <><CheckIcon size={13}/> {confirmLabel||'Confirmar'}</>}
            </button>
          </div>
          {erro && <div style={{fontSize:'11px',color:'var(--danger)',marginTop:'5px',display:'flex',gap:'4px',alignItems:'center'}}><AlertIcon size={11}/>{erro}</div>}
        </div>
      )}
    </div>
  );
}

export default function MinhasReservas() {
  const navigate = useNavigate();
  const [reservas,   setReservas]   = useState([]);
  const [load,       setLoad]       = useState(true);
  const [activeTab,  setActiveTab]  = useState('todas');
  const [sucesso,    setSucesso]    = useState('');
  const [erro,       setErro]       = useState('');
  const [avalModal,  setAvalModal]  = useState(null);
  const [avaliadas,  setAvaliadas]  = useState(new Set());
  // OTP state por reserva
  const [otpVisiveis,  setOtpVisiveis]  = useState({}); // { reservaId: '1234' }
  const [otpInputs,    setOtpInputs]    = useState({}); // { reservaId: '1234' }
  const [otpLoading,   setOtpLoading]   = useState({}); // { reservaId: true }
  const [otpErros,     setOtpErros]     = useState({}); // { reservaId: 'msg' }
  const [acaoLoading,     setAcaoLoading]     = useState({}); // { reservaId: true }
  // Modal disputa
  const [disputaModal,    setDisputaModal]    = useState(null);
  const [disputaMotivo,   setDisputaMotivo]   = useState('');
  const [disputaDesc,     setDisputaDesc]     = useState('');
  const [disputaFicheiros,setDisputaFicheiros]= useState([]);

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    setLoad(true);
    try {
      const data = await apiFetch('/cliente/reservas');
      setReservas(data.reservas || []);
    } catch(e) { setErro(e.message); }
    finally { setLoad(false); }
  };

  const setOtpVisivel  = (id, val) => setOtpVisiveis(p=>({...p,[id]:val}));
  const setOtpInput    = (id, val) => setOtpInputs(p=>({...p,[id]:val}));
  const setOtpLoadingR = (id, val) => setOtpLoading(p=>({...p,[id]:val}));
  const setOtpErro     = (id, val) => setOtpErros(p=>({...p,[id]:val}));
  const setAcaoLoadingR= (id, val) => setAcaoLoading(p=>({...p,[id]:val}));

  const buscarOtp = async (id, endpoint) => {
    setOtpLoadingR(id, true); setOtpErro(id, '');
    try {
      const data = await apiFetch(`/reservas/${id}/${endpoint}`);
      setOtpVisivel(id, data.otp);
    } catch(e) { setOtpErro(id, e.message); }
    finally { setOtpLoadingR(id, false); }
  };

  const confirmarOtpEntrega = async (id) => {
    setOtpLoadingR(id, true); setOtpErro(id, '');
    try {
      await apiFetch(`/reservas/${id}/confirmar-otp-entrega`, 'POST', { codigo: otpInputs[id] });
      setSucesso('Código confirmado! Aluguer activo.'); setTimeout(()=>setSucesso(''),4000);
      setOtpInput(id,''); setOtpVisivel(id,null);
      carregar();
    } catch(e) { setOtpErro(id, e.message); }
    finally { setOtpLoadingR(id, false); }
  };

  const iniciarDevolucao = async (id) => {
    setAcaoLoadingR(id, true);
    try {
      await apiFetch(`/reservas/${id}/iniciar-devolucao`, 'POST', {});
      setSucesso('Devolução iniciada! Código gerado.'); setTimeout(()=>setSucesso(''),4000);
      carregar();
    } catch(e) { setErro(e.message); setTimeout(()=>setErro(''),3000); }
    finally { setAcaoLoadingR(id, false); }
  };

  const confirmarOtpDevolucao = async (id) => {
    setOtpLoadingR(id, true); setOtpErro(id, '');
    try {
      await apiFetch(`/reservas/${id}/confirmar-otp-devolucao`, 'POST', { codigo: otpInputs[id] });
      setSucesso('Devolução confirmada! Em inspeção pelo fornecedor.'); setTimeout(()=>setSucesso(''),4000);
      setOtpInput(id,''); setOtpVisivel(id,null);
      carregar();
    } catch(e) { setOtpErro(id, e.message); }
    finally { setOtpLoadingR(id, false); }
  };

  const abrirDisputa = async (id) => {
    if (!disputaMotivo.trim()) { setErro('Indica o motivo da disputa'); return; }
    setAcaoLoadingR(id, true);
    try {
      const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
      const token = localStorage.getItem('kialuga_token');
      const fd = new FormData();
      fd.append('motivo', disputaMotivo);
      fd.append('descricao', disputaDesc);
      disputaFicheiros.forEach(f => fd.append('evidencias', f));
      const res  = await fetch(`${BASE_URL}/reservas/${id}/disputa`, {
        method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: fd,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.mensagem || 'Erro ao submeter disputa');
      setSucesso('Disputa registada. A KiAluga vai analisar.'); setTimeout(()=>setSucesso(''),4000);
      setDisputaModal(null); setDisputaMotivo(''); setDisputaDesc(''); setDisputaFicheiros([]);
      carregar();
    } catch(e) { setErro(e.message); setTimeout(()=>setErro(''),3000); }
    finally { setAcaoLoadingR(id, false); }
  };

  const tabs = [
    { id:'todas',     label:'Todas',      count: reservas.length },
    { id:'ativa',     label:'Em curso',   count: reservas.filter(r=>ESTADOS_ATIVOS.includes(r.estado)).length },
    { id:'concluida', label:'Concluídas', count: reservas.filter(r=>r.estado==='concluida').length },
    { id:'cancelada', label:'Canceladas', count: reservas.filter(r=>r.estado==='cancelada').length },
  ];

  const filtradas = reservas.filter(r => {
    if (activeTab === 'todas')    return true;
    if (activeTab === 'ativa')    return ESTADOS_ATIVOS.includes(r.estado);
    return r.estado === activeTab;
  });

  return (
    <>
      {/* Modal disputa */}
      {disputaModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.65)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}
          onClick={e=>{if(e.target===e.currentTarget){setDisputaModal(null);setDisputaFicheiros([]);}}}>
          <div style={{background:'var(--card)',borderRadius:'16px',padding:'24px',width:'100%',maxWidth:'460px',border:'1px solid var(--border)',maxHeight:'90vh',overflowY:'auto'}}>
            <div style={{fontSize:'15px',fontWeight:'700',marginBottom:'4px',color:'var(--danger)'}}>Abrir disputa</div>
            <div style={{fontSize:'12px',color:'var(--text-muted)',marginBottom:'16px'}}>A KiAluga analisará e mediará o processo.</div>
            <div style={{marginBottom:'12px'}}>
              <div style={{fontSize:'12px',fontWeight:'600',marginBottom:'5px'}}>Motivo *</div>
              <input value={disputaMotivo} onChange={e=>setDisputaMotivo(e.target.value)} placeholder="Ex: produto danificado, fornecedor não entregou..."
                style={{width:'100%',padding:'9px 12px',border:'1px solid var(--border)',borderRadius:'8px',fontSize:'13px',fontFamily:'inherit',outline:'none',background:'var(--card)',color:'var(--text-primary)',boxSizing:'border-box'}}/>
            </div>
            <div style={{marginBottom:'12px'}}>
              <div style={{fontSize:'12px',fontWeight:'600',marginBottom:'5px'}}>Descrição detalhada</div>
              <textarea value={disputaDesc} onChange={e=>setDisputaDesc(e.target.value)} rows={3} placeholder="Descreve o problema com detalhe..."
                style={{width:'100%',padding:'9px 12px',border:'1px solid var(--border)',borderRadius:'8px',fontSize:'13px',fontFamily:'inherit',outline:'none',background:'var(--card)',color:'var(--text-primary)',resize:'vertical',boxSizing:'border-box'}}/>
            </div>
            <div style={{marginBottom:'16px'}}>
              <div style={{fontSize:'12px',fontWeight:'600',marginBottom:'5px'}}>
                Evidências <span style={{fontWeight:'400',color:'var(--text-muted)'}}>— fotos/PDF, máx. 5 ficheiros</span>
              </div>
              <label style={{display:'block',border:'1.5px dashed var(--border)',borderRadius:'8px',padding:'14px',textAlign:'center',cursor:'pointer'}}
                onDragOver={e=>{e.preventDefault();e.currentTarget.style.borderColor='var(--danger)'}}
                onDragLeave={e=>{e.currentTarget.style.borderColor='var(--border)'}}
                onDrop={e=>{e.preventDefault();e.currentTarget.style.borderColor='var(--border)';
                  const novos=[...disputaFicheiros,...Array.from(e.dataTransfer.files)].slice(0,5);
                  setDisputaFicheiros(novos);}}>
                <input type="file" multiple accept="image/*,.pdf" style={{display:'none'}}
                  onChange={e=>{const novos=[...disputaFicheiros,...Array.from(e.target.files)].slice(0,5);setDisputaFicheiros(novos);e.target.value='';}}/>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{marginBottom:'5px'}}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                <div style={{fontSize:'12px',color:'var(--text-muted)'}}>Clica ou arrasta ficheiros aqui</div>
              </label>
              {disputaFicheiros.length > 0 && (
                <div style={{display:'flex',flexWrap:'wrap',gap:'8px',marginTop:'10px'}}>
                  {disputaFicheiros.map((f,i)=>(
                    <div key={i} style={{position:'relative',border:'1px solid var(--border)',borderRadius:'8px',overflow:'hidden',width:'70px',height:'70px',background:'var(--bg)'}}>
                      {f.type.startsWith('image/') ? (
                        <img src={URL.createObjectURL(f)} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                      ) : (
                        <div style={{width:'100%',height:'100%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'4px'}}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--danger)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                          <div style={{fontSize:'9px',color:'var(--text-muted)',textAlign:'center',marginTop:'3px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',width:'60px'}}>{f.name}</div>
                        </div>
                      )}
                      <button onClick={()=>setDisputaFicheiros(p=>p.filter((_,j)=>j!==i))}
                        style={{position:'absolute',top:'2px',right:'2px',width:'16px',height:'16px',borderRadius:'50%',background:'rgba(220,38,38,0.85)',border:'none',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',padding:0}}>
                        <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div style={{display:'flex',gap:'8px'}}>
              <button className="btn btn-ghost" onClick={()=>{setDisputaModal(null);setDisputaFicheiros([]);}} style={{flex:1}}>Cancelar</button>
              <button className="btn" onClick={()=>abrirDisputa(disputaModal)} disabled={acaoLoading[disputaModal]}
                style={{flex:2,background:'var(--danger)',color:'#fff',border:'none',display:'flex',alignItems:'center',justifyContent:'center',gap:'6px'}}>
                {acaoLoading[disputaModal]?'A submeter...':'Confirmar disputa'}
              </button>
            </div>
          </div>
        </div>
      )}

      {avalModal && (
        <ModalAvaliacao
          reserva={avalModal}
          onClose={() => setAvalModal(null)}
          onSucesso={() => {
            setAvaliadas(prev => new Set([...prev, avalModal.id]));
            setSucesso('Avaliação publicada com sucesso!');
            setTimeout(() => setSucesso(''), 4000);
          }}
        />
      )}

      <div className="topbar">
        <div>
          <div className="topbar-title">As minhas reservas</div>
          <div className="topbar-sub">{reservas.length} no total · {reservas.filter(r=>['confirmada','entregue','em_uso'].includes(r.estado)).length} em curso</div>
        </div>
        <div className="topbar-actions">
          <button className="btn btn-outline" onClick={carregar} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <RefreshIcon size={14}/> Actualizar
          </button>
          <button className="btn btn-primary" onClick={()=>navigate('/cliente')} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <PackageIcon size={14}/> Explorar produtos
          </button>
        </div>
      </div>

      <div className="page-content">
        {erro    && <div style={{background:'var(--danger-bg)',border:'1px solid var(--danger-border)',borderRadius:'10px',padding:'11px 14px',marginBottom:'14px',fontSize:'13px',color:'var(--danger)',display:'flex',gap:'7px',alignItems:'center'}}><AlertIcon size={14}/>{erro}</div>}
        {sucesso && <div style={{background:'var(--success-bg)',border:'1px solid var(--success-border)',borderRadius:'10px',padding:'11px 14px',marginBottom:'14px',fontSize:'13px',color:'var(--success)',display:'flex',gap:'7px',alignItems:'center'}}><CheckIcon size={14}/>{sucesso}</div>}

        {/* Tabs */}
        <div style={{display:'flex',gap:'6px',marginBottom:'16px'}}>
          {tabs.map(t=>(
            <button key={t.id} onClick={()=>setActiveTab(t.id)} style={{
              padding:'7px 14px',borderRadius:'8px',fontSize:'12px',fontWeight:'500',cursor:'pointer',fontFamily:'inherit',transition:'all 0.15s',
              background:activeTab===t.id?'var(--orange)':'var(--card)',
              color:activeTab===t.id?'#fff':'var(--text-secondary)',
              border:`1px solid ${activeTab===t.id?'var(--orange)':'var(--border)'}`,
            }}>
              {t.label} ({t.count})
            </button>
          ))}
        </div>

        {load ? (
          <div style={{textAlign:'center',padding:'60px',color:'var(--text-muted)'}}>
            <ClockIcon size={32} color='var(--border)'/>
            <div style={{marginTop:'10px'}}>A carregar reservas...</div>
          </div>
        ) : filtradas.length === 0 ? (
          <div className="card" style={{textAlign:'center',padding:'60px'}}>
            <ReceiptIcon size={36} color='var(--border)'/>
            <div style={{fontSize:'15px',fontWeight:'600',margin:'12px 0 6px'}}>
              {activeTab==='todas' ? 'Ainda não fizeste reservas' : 'Sem reservas neste estado'}
            </div>
            <div style={{fontSize:'13px',color:'var(--text-muted)',marginBottom:'20px'}}>
              {activeTab==='todas' ? 'Explora os produtos disponíveis e faz a tua primeira reserva!' : 'As reservas neste estado aparecem aqui.'}
            </div>
            {activeTab==='todas' && (
              <button className="btn btn-primary" onClick={()=>navigate('/cliente')} style={{display:'inline-flex',alignItems:'center',gap:'6px'}}>
                <PackageIcon size={14}/> Explorar produtos <ArrowRightIcon size={14}/>
              </button>
            )}
          </div>
        ) : (
          <div style={{display:'flex',flexDirection:'column',gap:'12px'}}>
            {filtradas.map(r => {
              const est       = ESTADOS[r.estado] || { label:r.estado, cls:'badge-neutral', desc:'' };
              const jaAvaliou = avaliadas.has(r.id) || r.avaliado;
              return (
                <div key={r.id} className="card">
                  <div style={{display:'flex',gap:'12px',alignItems:'flex-start'}}>
                    <div style={{width:'64px',height:'64px',borderRadius:'10px',overflow:'hidden',flexShrink:0,background:'linear-gradient(135deg,#fde8d8,#fed7b0)',display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer'}}
                      onClick={()=>navigate(`/cliente/produto/${r.anuncio_id}`)}>
                      {r.fotos?.[0]
                        ? <img src={r.fotos[0]} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/>
                        : <PackageIcon size={24} color='#F97316'/>
                      }
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:'8px',marginBottom:'6px'}}>
                        <div>
                          <div style={{fontSize:'14px',fontWeight:'600',color:'var(--text-primary)',cursor:'pointer',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxWidth:'300px'}}
                            onClick={()=>navigate(`/cliente/produto/${r.anuncio_id}`)}>
                            {r.titulo||'Produto'}
                          </div>
                          <div style={{fontSize:'12px',color:'var(--text-muted)',marginTop:'2px'}}>
                            Fornecedor: <strong>{r.fornecedor_nome||'—'}</strong>
                          </div>
                        </div>
                        <span className={`badge ${est.cls}`}>{est.label}</span>
                      </div>

                      <div style={{fontSize:'11px',color:'var(--info)',background:'var(--info-bg)',border:'1px solid var(--info-border)',borderRadius:'6px',padding:'4px 9px',marginBottom:'8px',display:'inline-block'}}>
                        {est.desc}
                      </div>

                      <div style={{display:'flex',gap:'16px',flexWrap:'wrap',marginBottom:'10px'}}>
                        {[
                          ['De',     new Date(r.data_inicio).toLocaleDateString('pt-PT')],
                          ['Até',    new Date(r.data_fim).toLocaleDateString('pt-PT')],
                          ['Dias',   `${r.total_dias}`],
                          ['Aluguer',`${parseFloat(r.valor_aluguer||0).toLocaleString()} Kz`],
                          ['Caução', r.caucao_devolvida ? 'Devolvida' : `${parseFloat(r.valor_caucao||0).toLocaleString()} Kz`],
                        ].map(([l,v])=>(
                          <div key={l}>
                            <div style={{fontSize:'10px',color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.3px'}}>{l}</div>
                            <div style={{fontSize:'12px',fontWeight:'600',color: l==='Caução'&&r.caucao_devolvida?'var(--success)':'var(--text-primary)'}}>{v}</div>
                          </div>
                        ))}
                      </div>

                      {/* ── Painel OTP entrega (Modo A: cliente VÊ o código) ── */}
                      {['confirmada','em_transito_entrega'].includes(r.estado) && r.modo_entrega !== 'levantamento' && (
                        <PainelOtp
                          titulo="Código de entrega (OTP #1)"
                          instrucao="Mostra este código verbalmente ao fornecedor quando ele chegar com o produto."
                          otp={otpVisiveis[r.id]}
                          onBuscarOtp={!otpVisiveis[r.id] ? () => buscarOtp(r.id, 'otp-entrega') : null}
                          loading={otpLoading[r.id]}
                          erro={otpErros[r.id]}
                        />
                      )}
                      {/* ── Painel OTP entrega (Modo B: cliente INTRODUZ o código do fornecedor) ── */}
                      {r.estado === 'aguardando_levantamento' && r.modo_entrega === 'levantamento' && (
                        <PainelOtp
                          titulo="Confirmar levantamento (OTP #1)"
                          instrucao="Pede o código ao fornecedor no ponto de levantamento e introduz abaixo."
                          inputVal={otpInputs[r.id]||''}
                          onChangeInput={v=>setOtpInput(r.id,v)}
                          onConfirmar={()=>confirmarOtpEntrega(r.id)}
                          loading={otpLoading[r.id]}
                          erro={otpErros[r.id]}
                          confirmLabel="Confirmar levantamento"
                        />
                      )}
                      {/* ── Painel devolução: OTP #2 Modo A: cliente INTRODUZ código do fornecedor ── */}
                      {r.estado === 'em_transito_devolucao' && r.modo_entrega !== 'levantamento' && (
                        <PainelOtp
                          titulo="Confirmar devolução (OTP #2)"
                          instrucao="Pede o código de devolução ao fornecedor e introduz abaixo para confirmar a entrega."
                          inputVal={otpInputs[r.id]||''}
                          onChangeInput={v=>setOtpInput(r.id,v)}
                          onConfirmar={()=>confirmarOtpDevolucao(r.id)}
                          loading={otpLoading[r.id]}
                          erro={otpErros[r.id]}
                          confirmLabel="Confirmar devolução"
                        />
                      )}
                      {/* ── Painel devolução: OTP #2 Modo B: cliente VÊ o código ── */}
                      {r.estado === 'em_transito_devolucao' && r.modo_entrega === 'levantamento' && (
                        <PainelOtp
                          titulo="Código de devolução (OTP #2)"
                          instrucao="Mostra este código ao fornecedor quando levares o produto de volta."
                          otp={otpVisiveis[r.id]}
                          onBuscarOtp={!otpVisiveis[r.id] ? () => buscarOtp(r.id, 'otp-devolucao') : null}
                          loading={otpLoading[r.id]}
                          erro={otpErros[r.id]}
                        />
                      )}

                      <div style={{display:'flex',gap:'6px',flexWrap:'wrap',marginTop:'8px'}}>
                        {r.estado === 'aluguer_ativo' && (
                          <button className="btn btn-primary btn-sm" onClick={()=>iniciarDevolucao(r.id)}
                            disabled={acaoLoading[r.id]}
                            style={{display:'flex',alignItems:'center',gap:'5px'}}>
                            <ReturnIcon size={12}/> {acaoLoading[r.id]?'A processar...':'Iniciar devolução'}
                          </button>
                        )}
                        {/* Legado */}
                        {r.estado === 'em_uso' && (
                          <button className="btn btn-primary btn-sm" onClick={()=>iniciarDevolucao(r.id)}
                            disabled={acaoLoading[r.id]}
                            style={{display:'flex',alignItems:'center',gap:'5px'}}>
                            <ReturnIcon size={12}/> Iniciar devolução
                          </button>
                        )}
                        {ESTADOS_CHAT.includes(r.estado) && (
                          <button className="btn btn-sm" onClick={()=>navigate(`/cliente/chat/${r.id}`)}
                            style={{background:'var(--primary)',color:'#fff',border:'none',display:'flex',alignItems:'center',gap:'5px'}}>
                            <MessageIcon size={12}/> Chat
                          </button>
                        )}
                        {r.estado === 'concluida' && !jaAvaliou && (
                          <button className="btn btn-sm" style={{background:'#FFFBEB',color:'#D97706',border:'1px solid #FDE68A',display:'flex',alignItems:'center',gap:'5px'}}
                            onClick={() => setAvalModal(r)}>
                            <StarIcon size={12} color='#D97706'/> Avaliar produto
                          </button>
                        )}
                        {r.estado === 'concluida' && jaAvaliou && (
                          <span style={{fontSize:'11px',color:'var(--success)',display:'flex',alignItems:'center',gap:'4px'}}>
                            <CheckIcon size={12}/> Avaliado
                          </span>
                        )}
                        {['aluguer_ativo','em_inspecao'].includes(r.estado) && (
                          <button className="btn btn-sm" onClick={()=>setDisputaModal(r.id)}
                            style={{background:'rgba(220,38,38,0.1)',color:'var(--danger)',border:'1px solid rgba(220,38,38,0.25)',display:'flex',alignItems:'center',gap:'5px'}}>
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                            Abrir disputa
                          </button>
                        )}
                        <button className="btn btn-ghost btn-sm" onClick={()=>navigate(`/cliente/produto/${r.anuncio_id}`)} style={{display:'flex',alignItems:'center',gap:'5px'}}>
                          <PackageIcon size={12}/> Ver produto
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
